import { render, staticRenderFns } from "./SubcontractorContractValueDisplay.vue?vue&type=template&id=0f53d319&scoped=true&"
import script from "./SubcontractorContractValueDisplay.vue?vue&type=script&lang=js&"
export * from "./SubcontractorContractValueDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SubcontractorContractValueDisplay.vue?vue&type=style&index=0&id=0f53d319&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f53d319",
  null
  
)

export default component.exports